import axios from "axios";
import router from 'router';



export const login = ({ commit, state }, credential) => {

    return axios.post(state.hostAPI + 'Login.php', credential)
        .then(response => {

            if (response.request.statusText == "OK") {


                if (response.data == "Error") {
                    return "Error"
                } else {

                    var role = response.data.role;
                    var token = response.data.token;

                    console.log(role)

                    commit('ROLE', role);
                    localStorage.setItem('token', token);
                    axios.defaults.headers.common['Authorization'] = token;
                    commit('LOGIN');
                    return "ok"
                }


            } else {

                localStorage.removeItem('token');
                commit('LOGOUT');
                return "Error";
            }

        })
        .catch(error => {
            console.log("login error: " + error)
            localStorage.removeItem('token');
            commit('LOGOUT');
            return "error";
        })
}

export const logout = ({ state, commit }) => {



    axios.post(state.hostAPI + "Logout.php", {


        })
        .then(response => {

            localStorage.removeItem('token');
            //localStorage.clear();
            commit('LOGOUT');
            commit('ROLE', "");
        })
        .catch(error => {

            console.log("logout: " + error)

        })




    //router.push({path: '/login'});

}




export const getAllData = ({ commit, state }, obj) => {

    var k = obj.id;
    var range = obj.range;
    axios({
            method: 'GET',
            url: state.hostAPI + 'GetRange.php?k=' + k + '&days=' + range,


        })
        .then(response => {
            var obj = {
                data: response.data,
                id: k
            }
            commit('GETTEDDATA', obj);
            //console.log(response)
            //return response.data;
        })
        .catch(error => {
            console.log(error)

        })
}

export const getLast = ({ commit, state }, objData) => {


    return axios({
            method: 'GET',
            url: state.hostAPI + 'GetLast.php?k=' + objData.id,


        })
        .then(response => {
            //commit('LOGIN')
            //console.log(response.data)
            return response.data;
        })
        .catch(error => {
            console.log(error)
            return error
        })
}

export const getLimits = ({ commit, state }, obj) => {

    return axios({
            method: 'GET',
            url: state.hostAPI + 'GetLimits.php?l=' + obj.id,


        })
        .then(response => {

            //console.log(response.data)
            return response.data;
        })
        .catch(error => {
            console.log(error)
            return error
        })
}


export const setLimits = ({ commit, state }, obj) => {


    return axios.post(state.hostAPI + 'SetLimits.php', obj)
        .then(function(response) {

            return response.data
        })
        .catch(function(error) {
            console.log(error);
        });

}

export const getValid = ({ commit, state }, obj) => {

    return axios({
            method: 'GET',
            url: state.hostAPI + 'GetValid.php?k=' + obj.id,


        })
        .then(response => {


            return response.data;
        })
        .catch(error => {
            console.log(error)
            return error
        })
}

export const setProps = ({ commit, state }, obj) => {



    return axios.post(state.hostAPI + 'SetProps.php', obj)
        .then(function(response) {

            return response.data
        })
        .catch(function(error) {
            console.log(error);
        });

}

export const getProps = ({ commit, state }) => {

    return axios({
            method: 'GET',
            url: state.hostAPI + 'GetProps.php',


        })
        .then(response => {


            return response.data;
        })
        .catch(error => {
            //console.log(error)
            return error
        })
}